import { Component, Inject, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Auth } from 'aws-amplify';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-backoffice-transactions',
  templateUrl: './Config.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class Configcomponent implements OnInit {
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  canAccess = false;
  balanceAmount: number | null = null;
  owner: string | null = null;

  // Configs
  ConfigList: any[] = [];
  visibleConfigs: any[] = [];
  configsPerPage = 10;

  hasMoreConfigs = true;
  loadingConfig = false;

  filteredCounts: { ConfigList: number } = { ConfigList: 0 };


  // Filtros
  filterConfigs: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    await this.auth.refresh();
    this.user = await Auth.currentAuthenticatedUser();
    this.owner = this.route.snapshot.queryParamMap.get('owner');
    await this.getConfigList();
  }

  async getConfigList(): Promise<void> {
    if (this.loadingConfig || !this.hasMoreConfigs) return;

    this.loadingConfig = true;
    const queryParams: any = {
      opcion: "4", // Obtener todas las configuraciones
      owner: this.owner || ''
    };

    try {
      const response = await this.lambda.getLambdaFunction('lambda', '/Configs', {
        queryStringParameters: queryParams
      });

      const configs = response.datos || [];



      if (Array.isArray(configs)) {
        this.ConfigList = configs;
  

        console.log('ConfigList:', this.ConfigList);
        console.log('VisibleConfigs:', this.visibleConfigs);

        // Preparar filtros
        const uniqueModulos = Array.from(
          new Set(configs.map((item: any) => item.Modulo || '')) 
        ).filter(Boolean).map(mod => ({
          key: mod,
          value: mod
        }));

        this.filterConfigs = [
          { key: 'id', type: 'text', label: "Identificador" },
          { key: 'Modulo', type: 'select', label: "Módulo", options: uniqueModulos },
          { key: 'nombre', type: 'text', label: "Nombre" },
        ];
      } else {
        this.hasMoreConfigs = false;
      }
    } catch (error) {
      console.error('Error al obtener configuraciones:', error);
    } finally {
      this.loadingConfig = false;
    }
  }


  async loadMoreConfigs(page: number): Promise<void> {
    console.log('Page changed to:', page);
  
    // console.log(this.hasMoreConfigs,'...',this.loadingConfig);
    // if (this.hasMoreConfigs && !this.loadingConfig) {
    //   await this.getConfigList();
   // }
  }
  
  onFiltersChanged(filters: any) {
    console.log('Filters updated:', filters);
  }

  onConfigClick(config: any): void {
    this.router.navigate(['/backoffice/config/edit'], {
      queryParams: {
        id: config.id,
        nombre: config.nombre,
        Modulo: config.Modulo,
        valor: config.valor,
        Descripcion: config.Descripcion,
        activo: config.activo,
        createdAt: config.createdAt,
        updatedAt: config.updatedAt,
      },
    });
  }



  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
